module.exports = __webpack_public_path__ + "static/media/40.ed8d0637.png";